export default {"src":"/_next/static/media/twitter-black.716f455c.svg","height":11,"width":12};